/*
    LOG object : {
        type: Type of LOG_TYPE,
        body: The actual log body
    }
*/
let logs = [];
let fullTrace = '';

export const LOG_TYPE = {
    ACTION: 'ACTION',
    ERROR: 'ERROR',
    INFO: 'INFO'
};

const SENSITIVE_PAYLOAD_ACTIONS = [
    'FETCH_METADATA_SUCCESS',
    'FETCH_SCORECARD_SUCCESS',
    'USER_LOGIN_SUCCESS',
    'SEAL_SYSTEMS_UPDATE_ALL',
    'SEAL_SYSTEM_UPDATE',
    'FETCH_LIBRARY_SUCCESS',
    'UPDATE_USERS_USERVIEWS',
    'DOCUMENT_VIEWS_SUCCESS',
    'USER_LOGIN_REQUEST'
];

const SENSITIVE_METHODS = ['authentication.login', 'documentActions.getSealViewsPromise'];

function zeroPad(num, padlen) {
    const pad = new Array(1 + padlen).join('0');
    return (pad + num).slice(-pad.length);
}

export function addLog(type, method, log) {
    const now = new Date();
    const month = `${zeroPad(now.getMonth() + 1, 2)}`;
    const day = `${zeroPad(now.getDate(), 2)}`;
    const logDate = `${now.getFullYear()}-${month}-${day}`;
    const hours = `${zeroPad(now.getHours(), 2)}`;
    const minutes = `${zeroPad(now.getMinutes(), 2)}`;
    const seconds = `${zeroPad(now.getSeconds(), 2)}`;
    const logTime = `${hours}:${minutes}:${seconds}`;
    const logDatetime = `${logDate} ${logTime}`;

    let sensitiveAction = '';
    if (SENSITIVE_METHODS.includes(method)) {
        log = '#anonymized#';
    }

    SENSITIVE_PAYLOAD_ACTIONS.forEach(dispatchAction => {
        if (
            sensitiveAction === '' &&
            log &&
            log !== undefined &&
            JSON.stringify(log).indexOf(dispatchAction) > -1
        ) {
            sensitiveAction = dispatchAction;
        }
    });

    if (sensitiveAction !== '') {
        log = `{'type':'{${sensitiveAction}}','payload':#anonymized#}`;
    }

    logs.push({
        logDatetime,
        type,
        method,
        log
    });
}
export function getLogs(type = 'ALL') {
    if (!type || type === 'ALL') return logs;
    return logs.filter(log => log.type === type);
}
export function clearLogs() {
    logs = [];
}

export function getFullTrace() {
    writeTrace();
    return fullTrace;
}

function writeTrace() {
    const maxLogSize = 1000000; // 1MB
    const logMessageMaxSize = 8192; // 8192 8K
    fullTrace = 'End of log';
    let indx = logs.length - 1;
    while (fullTrace && fullTrace.length < maxLogSize && indx >= 0) {
        let logMessage = JSON.stringify(logs[indx].log);

        // limit each log message length
        if (fullTrace && logMessage && logMessage.length > logMessageMaxSize)
            logMessage = `${logMessage.substring(0, logMessageMaxSize)} ...`;
        // trim leading/trailing double quote
        if (fullTrace && logMessage && logMessage.length > 1) {
            logMessage = logMessage.substring(1, logMessage.length - 1);
        }

        const logEntry = `${logs[indx].logDatetime}\t${logs[indx].type}\t${
            logs[indx].method
        }\t${logMessage}`;

        if (fullTrace && logEntry && fullTrace.length + logEntry.length < maxLogSize) {
            fullTrace = `${logEntry}\n${fullTrace}`;
        } else {
            break;
        }
        indx -= 1;
    }
}
